function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React from 'react';
import Heading from './Heading';
export const PageTitle = _ref => {
  let {
    as = 'h1',
    fontSize = ['mobileTitle', 'title'],
    mb = 5,
    textAlign = ['center', 'left'],
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Heading, _extends({
    as: as,
    fontSize: fontSize,
    mb: mb,
    textAlign: textAlign
  }, props));
};
PageTitle.propTypes = {
  ...Heading.propTypes,
  children: PropTypes.any.isRequired
};
PageTitle.displayName = 'PageTitle';
export default PageTitle;